/**
 * F.O.W brand mark with a small TM badge in the top-right corner.
 *
 * The TM circle inherits its color from the surrounding text via
 * `currentColor`, so wherever you place this, the badge automatically
 * matches the F.O.W text color. Sizes scale with the parent font.
 * 
 * @param {string} size - 'xsmall' for sidebar/header, 'small', 'normal' (default) for login/signup
 */
const FowBrand = ({ className = '', size = 'normal' }) => {
  const sizes = {
    xsmall: {
      width: '0.55em',
      height: '0.55em',
      marginLeft: '0.1em',
      padding: '0.07em',
      fontSize: '0.22em',
    },
    small: {
      width: '0.55em',
      height: '0.55em',
      marginLeft: '0.1em',
      padding: '0.06em',
      fontSize: '0.22em',
    },
    normal: {
      width: '0.7em',
      height: '0.7em',
      marginLeft: '0.12em',
      padding: '0.08em',
      fontSize: '0.3em',
    },
  };

  const currentSize = sizes[size] || sizes.normal;

  return (
    <span className={`inline-flex items-start whitespace-nowrap ${className}`}>
      <span>F.O.W</span>
      <span
        aria-label="Trademark"
        className="inline-flex items-center justify-center rounded-full leading-none"
        style={{
          width: currentSize.width,
          height: currentSize.height,
          marginLeft: currentSize.marginLeft,
          marginTop: '0.05em',
          padding: currentSize.padding,
          boxSizing: 'border-box',
          borderStyle: 'solid',
          borderColor: 'currentColor',
          borderWidth: '1px',
          color: 'currentColor',
          flexShrink: 0,
        }}
      >
        <span
          style={{
            fontSize: currentSize.fontSize,
            fontWeight: 700,
            lineHeight: 1,
            display: 'block',
            transform: 'translateY(0.08em)',
          }}
        >
          TM
        </span>
      </span>
    </span>
  );
};

export default FowBrand;
